
























































































































import Vue from "vue"
import { required } from "vuelidate/lib/validators"
import * as _ from "lodash"
import * as Cookies from "es-cookie"
import LoginHeader from "@/components/header/LoginHeader.vue"
import PinInput from "@/components/login/PinInput.vue"

export default Vue.extend({
  components: { PinInput, LoginHeader },
  data() {
    return {
      loginRequest: {
        username: null,
        password: null
      },
      errorMessage: "",
      errorKey: "",
      qrUrl: "",
      visible: false,
      identifier: "",
      twoFactorEnabled: false,
      pinInput: "",
      jwtUsername: null as string | null
    }
  },
  created() {
    const token = Cookies.get("application_jwt")
    if (!token) {
      return
    }
    const payload = this.decodeJwtPayload(token)
    if (!payload || typeof payload.exp !== "number") {
      return
    }
    const isValid = payload.exp * 1000 > Date.now()
    if (payload.auth_level === "PARTIAL" && isValid) {
      // Mid-2FA cookie — the previous session's isVerified flag is stale.
      localStorage.setItem("isVerified", "false")
      this.twoFactorEnabled = true
      this.jwtUsername = payload.username
    }
  },
  validations: {
    loginRequest: {
      username: {
        required
      },
      password: {
        required
      }
    }
  },
  methods: {
    decodeJwtPayload(token: string): any {
      try {
        const b64 = token.split(".")[1].replace(/-/g, "+").replace(/_/g, "/")
        return JSON.parse(atob(b64))
      } catch (e) {
        return null
      }
    },
    getValidator(field: string, validation: string) {
      const vm = this
      return (rule: any, value: any, callback: any) => {
        if ((vm.$v.loginRequest as any)[field].$dirty && !(vm.$v.loginRequest as any)[field][validation]) {
          callback(new Error(this.$t(`login.validation.${field}.${validation}`).toString()))
        } else {
          callback()
        }
      }
    },
    login() {
      const vm = this
      vm.errorKey = ""
      // Fresh username/password attempt — any prior 2FA session flag is stale.
      localStorage.setItem("isVerified", "false")
      vm.startLoad()
      this.$store
        .dispatch("login", this.loginRequest)
        .then(() => {
          vm.endLoad()
          this.twoFactorEnabled = this.$store.state.authenticatedEmployee.twoFactorEnabled

          if (this.twoFactorEnabled && !this.$store.state.authenticatedEmployee.twoFactorConfirmed) {
            vm.$http.get(
              `/2fa/qr?username=${this.$store.state.authenticatedEmployee.username}`,
              { responseType: "blob" }
            ).then(res => {
              this.qrUrl = URL.createObjectURL(res.data)
            })
          } else {
            if (vm.$router.currentRoute.query.redirect) {
              vm.$router.push(this.$router.currentRoute.query.redirect.toString())
            } else {
              vm.$router.push("/")
            }
            }
        })
        .catch(e => {
          vm.errorKey = e.message
          const translate = this.$store.state.languagesFromBase[this.$root.$i18n.locale]
          vm.errorMessage = _.get(translate, vm.errorKey)
          vm.endLoad()
        })
    },
    submit() {
      const vm = this
      if (vm.resetValid) {
        vm.startLoad()
        vm.$http
          .post("/login/reset", {
            identifier: vm.identifier
          }, {
            headers: {
              "client_lang": this.$root.$i18n.locale
            }
          })
          .then((res) => {
            vm.endLoad()
            if (exists(res.data.status)) {
              vm.$error(res.data.message)
            } else {
              this.$message({
                message: vm.$t(res.data).toString(),
                type: "success",
                duration: 7000
              })
            }
          })
          .catch(e => {
            vm.$error(e.message)
            vm.endLoad()
          })
      }
    },
    submitPin(value: string) {
      const vm = this
      const employee = this.$store.state.authenticatedEmployee
      const username = (employee && employee.username) || this.jwtUsername
      this.$http
        .get(`/2fa/verify?username=${username}&code=${value}`)
        .then(res => {
          localStorage.setItem("isVerified", "true")
          vm.$store.commit("setAuthenticatedEmployee", res.data)
          vm.$router.replace("/")
        })
        .catch(e => {
          vm.$message({
            message: e && e.data ? e.data.toString() : "Verification failed",
            type: "error",
            duration: 3000
          })
        })
    },
    async logout() {
      localStorage.setItem("isVerified", "false")
      this.$store.commit("setAuthenticatedEmployee", null)
      this.$router.go(0)
    }
  },
  computed: {
    rules(): any {
      return {
        username: [{ validator: this.getValidator("username", "required"), trigger: "change" }],
        password: [{ validator: this.getValidator("password", "required"), trigger: "change" }]
      }
    },
    resetValid(): boolean {
      return notEmpty(this.identifier)
    }
  },
  watch: {
    "$root.$i18n.locale": function() {
      if (this.errorKey) {
        const translate = this.$store.state.languagesFromBase[this.$root.$i18n.locale]
        this.errorMessage = _.get(translate, this.errorKey)
      }

}
  }
})
